import React from 'react';
import {Button, Tooltip} from "@material-ui/core";
import {HashLink as Link} from "react-router-hash-link";
import {useSelector} from "react-redux";
import ComingSoonIconSettings from "./ComingSoonIconSettings";

const ChangeEmailTextInput = ({customer = null,})=> {

    const authUser = useSelector(({auth}) => auth.authUser);

    const isDisabled = true;
    const textColor = isDisabled && "text-light-gray";


    return(
            <div className={`row mt-1 ${textColor}`}>
                <Tooltip title={""}>
                    <>
                        <p className={"col-5 text-right align-self-center"}>Current Email:</p>
                        <p className={"col-1"}> </p>
                        <div className={"col-5 text-left"}>
                            <input type="text"
                                   id="email"
                                   name="email"
                                   placeholder={`${authUser.user.email}`}
                                   readOnly
                            />
                            &nbsp;
                            <Button
                                component={Link}
                                // smooth
                                to={'/password'}
                                variant={"outlined"}
                                disabled
                            >
                                Change Email
                            </Button>
                        </div>
                    </>
                </Tooltip>
                <ComingSoonIconSettings/>
            </div>

    )
}

export default ChangeEmailTextInput;